import React, { useEffect, useState, useContext } from "react";
import * as notify from "../../shared/notify";

import AddNote from "../../components/notes/components/add-note";
import ClientPreferences from "../clients/components/client-preferences";
import DisplayNotes from "../../components/notes/components/display-notes";

import { getClients } from "../../components/shipment-editor/lib/shipmentData";
import { Typeahead } from "../../components/form-inputs/typeahead";
import { getNotes, updateNotes, sendNote, getTaskOptions } from "../../components/notes/lib/data";
import { ViewOnlyPermissionsContext } from "contexts/view-only-permissions/view-only-permissions";

const ClientNotes = () => {
    const { viewOnlyAdmin } = useContext(ViewOnlyPermissionsContext);
    const [selectedClient, setSelectedClient] = useState(null);
    const [clients, setClients] = useState([]);
    const [showArchived, setShowArchived] = useState(false);
    const [notes, setNotes] = useState({
        all: [],
        active: [],
        archived: [],
    });

    useEffect(() => {
        async function fetchData() {
            const clientsCxH = await getClients({ clientFilter: 3 });

            if (!clientsCxH) {
                return;
            }

            setClients(clientsCxH);
        }

        fetchData();
    }, []);

    useEffect(() => {
        async function fetchNotes() {
            if (selectedClient) {
                const noteData = await getNotes({
                    clientCode: selectedClient,
                });

                if (!noteData) {
                    return;
                }

                const clientNotes = noteData.filter((n) => n.noteType === "Client");

                setNotes({
                    all: clientNotes,
                    active: clientNotes.filter((n) => n.isActive),
                    archived: clientNotes.filter((n) => !n.isActive),
                });
            }
        }

        fetchNotes();
    }, [selectedClient]);

    const updateTypeahead = (name, value) => {
        const clientId = value && value.value ? value.value : null;
        setSelectedClient(clientId);
    };

    const onAdd = async (value, taskTypes) => {
        return new Promise(async (resolve) => {
            if (!selectedClient) {
                notify.error("Please select a client first.");
                resolve(false);
            }

            const tasksRequested = taskTypes.map((selection) => {
                return selection.value;
            });

            const noteItems =
                tasksRequested.length <= 0 || tasksRequested.includes("all")
                    ? [
                          {
                              noteText: value,
                              noteType: "Client",
                              clientCode: selectedClient,
                              taskType: "",
                          },
                      ]
                    : tasksRequested.map((task) => {
                          return {
                              noteText: value,
                              noteType: "Client",
                              clientCode: selectedClient,
                              taskType: task,
                          };
                      });

            const payload = {
                items: noteItems,
            };
            const response = await sendNote(payload, "adminclient");

            if (!response) {
                resolve(false);
            }

            if (response.length > 0) {
                setNotes({
                    all: [...response, ...notes.all],
                    active: [...response, ...notes.active],
                    archived: notes.archived,
                });
            }

            resolve(true);
        });
    };

    const toggleArchives = () => {
        setShowArchived(!showArchived);
    };

    const archiveNote = async (noteId) => {
        const response = await updateNotes([
            {
                noteId,
                isActive: false,
            },
        ]);

        if (!response) {
            return;
        }

        const [noteResponse] = response.results;

        setNotes((state) => ({
            ...state,
            active: notes.active.filter((n) => n.noteId !== noteId),
            archived: [{ ...noteResponse.note }, ...state.archived],
        }));
    };

    return (
        <div>
            <Typeahead
                label="Client"
                name="cxHCompany"
                options={clients}
                updateOnChange={updateTypeahead}
            />
            {selectedClient && !viewOnlyAdmin.createAssignmentNote && <h2>Notes</h2>}
            {selectedClient && !viewOnlyAdmin.createAssignmentNote && (
                <AddNote
                    addNote={onAdd}
                    label="Client Note"
                    taskOptions={getTaskOptions(true)}
                />
            )}
            {selectedClient && (
                <ClientPreferences
                    selectedClient={selectedClient}
                    disableImageApproval={viewOnlyAdmin.setImageApproval}
                    disablePremiumEditing={viewOnlyAdmin.setPremiumEditing}
                    disableSendToGDSN={viewOnlyAdmin.setSendToGDSN}
                />
            )}
            {notes.active.length > 0 && (
                <DisplayNotes
                    notes={notes.active}
                    archiveNote={archiveNote}
                    allowArchive={!viewOnlyAdmin.createAssignmentNote}
                />
            )}
            {notes.archived.length > 0 && (
                <div>
                    <button
                        className="button -text"
                        onClick={toggleArchives}
                    >
                        {showArchived ? "- Hide" : "+ Show"} {notes.archived.length} Archived Note{notes.archived.length > 1 ? "s" : ""}
                    </button>
                    <br />
                    <br />
                    <br />
                </div>
            )}
            {showArchived && notes.archived.length > 0 && (
                <DisplayNotes
                    notes={notes.archived}
                    archived={true}
                />
            )}
        </div>
    );
};

export default ClientNotes;
